import { AppShell } from "@/components/layout/AppShell";
import { CrudPanel } from "@/components/library/CrudPanel";
import { InstallerPanel } from "@/components/team/InstallerPanel";

export default function Users() {
  return (
    <AppShell title="Team Members">
      <p className="mb-4 text-sm text-gray-500">Admins manage everything. Sales reps only see and edit their own quotes, clone company templates, and need admin approval before sending.</p>
      <CrudPanel path="users" title="Office users (admins & sales reps)" testid="users" canEdit filterRows={(u) => u.role !== "installer"}
        fields={[
          { key: "name", label: "Name" }, { key: "email", label: "Email" },
          { key: "role", label: "Role", type: "select", options: [{ value: "rep", label: "Sales rep" }, { value: "admin", label: "Admin" }] },
          { key: "phone", label: "Mobile (for reply alerts by text)" },
          { key: "password", label: "Password", hideInTable: true },
        ]} />
      <InstallerPanel />
    </AppShell>
  );
}
